export default "__VITE_ASSET__Oru9t$A8__"